// @ts-ignore: No TS declaration present for the timezone data bundle.
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.js'

import type { GarageReservationTimeRange } from './types'
import type { TFunction } from 'i18next'

export type GarageParkingPeriod = {
    durationHours: number,
    endsAtLabel: string,
    endDay: number,
    endWeekday: number,
}

export function getGarageParkingPeriod(range: GarageReservationTimeRange | null): GarageParkingPeriod | null {
    if (!range?.beginsAt || !range.endsAt) return null

    const beginsAt = moment.parseZone(range.beginsAt, moment.ISO_8601, true).tz('Europe/Prague')
    const endsAt = moment.parseZone(range.endsAt, moment.ISO_8601, true).tz('Europe/Prague')
    if (!beginsAt.isValid() || !endsAt.isValid() || !endsAt.isAfter(beginsAt)) return null

    return {
        durationHours: endsAt.diff(beginsAt, 'hours', true),
        endsAtLabel: endsAt.format('HH:mm'),
        endDay: endsAt.clone().startOf('day').diff(beginsAt.clone().startOf('day'), 'days') + 1,
        endWeekday: endsAt.day(),
    }
}

export function getGarageParkingEndMessage(period: GarageParkingPeriod, t: TFunction, namespace: 'minimumStayPrice' | 'minimumStayDetail' | 'checkout.extensionAlert' = 'minimumStayPrice'): string {
    const key = period.endDay === 1 ? 'until'
        : period.endDay === 2 && period.endsAtLabel === '00:00' ? 'untilMidnight'
        : 'untilWeekday'
    return t(`${namespace}.${key}`, {
        endsAt: period.endsAtLabel,
        weekday: t(`minimumStayPrice.weekdays.${period.endWeekday}`),
    })
}
